<template>
  <div class="social-share">
    <Transition name="fade" mode="out-in">
      <div v-if="!shortLinkLoaded" key="loader" class="lodaer">
        <Loader />
      </div>
      <div v-else-if="!showQRcode" key="url" class="url">
        <div class="social-share-info">
          <div :style="coverBackgroundImage(cover)" class="cover">
            <!--  -->
          </div>
          <div class="box">
            <div class="subject">
              <div class="title">
                {{ title }}
              </div>
            </div>
            <div class="created">
              <div class="text">
                {{ subtitle }}
              </div>
            </div>
          </div>
        </div>
        <div class="social-share-list">
          <div class="icon" @click="socialShare('facebook')">
            <img src="@/assets/images/social/share/ic-fb.svg" alt="logo-fb">
          </div>
          <div class="icon" @click="socialShare('twitter')">
            <img src="@/assets/images/social/share/ic-twitter.svg" alt="logo-twitter">
          </div>
          <!-- <div class="icon" @click="socialShare('google')">
            <img src="@/assets/images/social/share/ic-google.svg" alt="logo-google">
          </div> -->
          <div class="icon" @click="socialShare('line')">
            <img src="@/assets/images/social/share/ic-line.png" alt="logo-line">
          </div>
          <div class="icon" @click="socialShare('plurk')">
            <img src="@/assets/images/social/share/ic-plurk.png" alt="logo-plurk">
          </div>
          <div class="icon" @click="socialShare('weibo')">
            <img src="@/assets/images/social/share/ic-weibo.png" alt="logo-weibo">
          </div>
          <div class="icon">
            <img src="@/assets/images/social/share/ic-wechat.png" alt="logo-wechat" @click="socialShare('wechat')">
          </div>
        </div>
        <SocialShareLink
          :share-link="shortLink || shareLink"
          :share-link-label="shareLinkLabel"
        />
      </div>
      <div v-else-if="showQRcode" key="qrcode" class="qrcode">
        <div class="qrcode-img">
          <img :src="qrcodeImgLink" alt="QR code">
        </div>
        <div class="qrcode-text">
          打开微信“扫一扫”，打开网页后点击屏幕右上角分享按钮
        </div>
        <a class="qrcode-back" @click="showQRcode = false">
          {{ $t('COMMON.CANCEL') }}
        </a>
      </div>
    </Transition>
  </div>
</template>
<script>
import Loader from '@/components/common/Loader'
import SocialShareLink from '@/components/common/SocialShareLink'
import ShortLinkService from '@/assets/services/ShortLinkService'
import { shareToTwitter, shareToFacebook, shareToGooglePlus, shareToLine, shareToWeibo, shareToPlurk, getURLsQRCode } from '@/assets/helpers/SocialHelper.js'

export default {
  name: 'SocialShare',
  components: {
    Loader,
    SocialShareLink
  },
  directives: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    cover: {
      type: String,
      default: ''
    },
    shareLink: {
      type: String,
      default: ''
    },
    shareLinkLabel: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showQRcode: false,
      shortLinkLoaded: false,
      shortLink: ''
    }
  },
  computed: {
    qrcodeImgLink() {
      return getURLsQRCode(this.shareLink, 200, 200) // dynamic get shareLink
    }
  },
  watch: {},
  created() {
    if (this.shareLink) {
      const params = {
        link: `${this.shareLink}?utm_source=website&utm_medium=share&utm_campaign=short_link`,
        socialMetaTagInfo: {}
      }
      ShortLinkService.short(params)
        .then((res) => {
          if (res && res.shortLink) {
            this.shortLink = res.shortLink
          }
          this.shortLinkLoaded = true
        })
    }
  },
  mounted() {},
  updated() {},
  methods: {
    getURLsQRCode, // mapping to method
    coverBackgroundImage(cover) {
      return cover ? { backgroundImage: `url(${cover})` } : {}
    },
    async socialShare(type) {
      const link = `${this.shareLink}?utm_source=${type}&utm_medium=share&utm_campaign=short_link`
      const shortLinkRes = await ShortLinkService.short({ link, socialMetaTagInfo: {} })
      const shortLinkWithUTM = shortLinkRes && shortLinkRes.shortLink
        ? shortLinkRes.shortLink
        : this.shareLink

      if (type === 'facebook') {
        this.$store.dispatch('GTAG_EVENT', { action: 'share', data: { method: 'facebook' } })
        shareToFacebook(shortLinkWithUTM)
      } else if (type === 'twitter') {
        this.$store.dispatch('GTAG_EVENT', { action: 'share', data: { method: 'twitter' } })
        shareToTwitter(shortLinkWithUTM)
      } else if (type === 'google') {
        this.$store.dispatch('GTAG_EVENT', { action: 'share', data: { method: 'google' } })
        shareToGooglePlus(shortLinkWithUTM)
      } else if (type === 'line') {
        this.$store.dispatch('GTAG_EVENT', { action: 'share', data: { method: 'line' } })
        shareToLine(shortLinkWithUTM)
      } else if (type === 'plurk') {
        this.$store.dispatch('GTAG_EVENT', { action: 'share', data: { method: 'plurk' } })
        shareToPlurk(shortLinkWithUTM)
      } else if (type === 'weibo') {
        this.$store.dispatch('GTAG_EVENT', { action: 'share', data: { method: 'weibo' } })
        shareToWeibo(shortLinkWithUTM)
      } else if (type === 'wechat') {
        this.$store.dispatch('GTAG_EVENT', { action: 'share', data: { method: 'wechat' } })
        this.shareLink = shortLinkWithUTM
        this.showQRcode = !this.showQRcode
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.social-share {
  &-info {
    margin-top: 24px;
    margin-bottom: 24px;
    .cover {
      float: left;
      position: relative;
      overflow: hidden;
      width: 130px;
      height: 116px;
      // min-height: 130px;
      border-radius: 12px;

      background-color: $grey-ec;
      background-image: url('/img/img-default/img-playlist-default-l.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      img {
        width: 130px;
        height: 116px;
        border-radius: 12px;
      }
      margin-right: 36px;
    }
    .box {
      position: relative;
      overflow: hidden;
      .subject {
        height: 32px;
        margin-bottom: 8px;
        .title {
          position: relative;
          overflow: hidden;

          font-size: 20px;
          font-weight: 500;
          line-height: 1.6;
          color: $grey-50;

          white-space: nowrap;
          // overflow: hidden; // exist by BFC
          text-overflow: ellipsis;
        }
      }
      .created {
        min-height: 20px;
        .text {
          position: relative;
          overflow: hidden;
          font-size: 12px;
          line-height: 20px;
          font-weight: 500;
          color: $grey-7d;
          white-space: nowrap;
          // overflow: hidden; // exist by BFC
          text-overflow: ellipsis;
        }

      }
    }
    &:after{
      content: "";
      display: block;
      clear: both;
    }
  }
  &-list {
    min-height: 40px;
    margin-bottom: 12px;
    // border: solid 1px $theme-red;
    .icon {
      display: inline-block;
      vertical-align: top;
      height: 40px;
      width: 40px;
      margin-right: 24px;
      margin-bottom: 24px;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;
    }
  }
  .lodaer {
    text-align: center;
  }
  .qrcode {
    text-align: center;
    &-back {
      display: inline-block;
      margin-top: 60px;
      font-size: 16px;
      color: $grey-9b;
      text-decoration: none;
      cursor: pointer;
    }
  }
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {
  .social-share {
    &-info {
      .cover {
        width: 136px;
        height: 120px;
        min-height: 128px;
        float: unset;
        text-align: center;
        text-align: center;
        margin: 0 auto;
        img {
          width: 136px;
          height: 120px;
        }
      }
      .box {
        .subject,
        .created {
          width: 100%;
          text-align: center;
        }
        .subject {
          height: auto;
          margin: 16px 0;
          .title {
            white-space: unset;
          }
        }
        .created {
          display: none;
          // margin: 0;
          // >.avatar {
          //   float: unset;
          // }
          // > .avatar, > .text {
          //   display: inline-block;
          //   white-space: normal;
          // }
        }
      }
    }
    &-list {
      margin-bottom: 24px;
      // text-align: center;
      .icon {
        height: 40px;
        width: 40px;
        margin-right: 16px;
        margin-bottom: 16px;
      }
    }
  }
}

</style>
